<template>
  <L1 class="mapsetting">
    <La :ratio="'0.74fr 1fr'"  :popupL="addnew">
      <template slot="left">
        <div class="title1">地點類別與圖示
        <AddBtn :style="{marginLeft: 'auto'}" :text="'新增類別'" :icon="'add'" :bg="'var(--color-pri)'" @click="addnew=true"/>
        </div>
        <Table :rows="[defaultcate, ...rows]">
          <template slot="slot_head">
            <th :style="{width: '72px', paddingRight: '22px'}">NO.</th>
            <th :style="{textAlign: 'start'}">地點類別</th>
            <th :style="{width: '80px', whiteSpace: 'nowrap'}">標註圖示</th>
            <th :style="{width: '126px', paddingRight: '46px', whiteSpace: 'nowrap'}">點擊圖示</th>
            <th :style="{width: '87px'}">刪除</th>
          </template>
          <tr slot-scope="item" :style="{height: '98px'}">
            <td :style="{paddingRight: '22px'}">{{item.index+1}}</td>
            <td :style="{textAlign: 'start'}">{{item.item.category}}</td>
            <td><img :src="`.${item.item.regular}`" alt=""></td>
            <td :style="{paddingRight: '46px'}"><img :src="`.${item.item.focus}`" alt=""></td>
            <td><DelBtn :disabled="!item.item.removable" :style="{margin: 'auto'}" @click="remove(item.index-1)"/></td>
          </tr>
        </Table>
      </template>
      <div :style="{paddingInline: '17px'}" v-if="production">
        <div class="title1" :style="{paddingLeft: '0'}">地圖語言總開關
        </div>
        <div class="switchs">
          <div>中文導覽 <SwitchBox :label1="'關閉'" :label2="'開啟'" :defaultValue="tw" @update="updateValue('tw', $event)"/></div>
          <div>英文導覽 <SwitchBox :label1="'關閉'" :label2="'開啟'" :defaultValue="en" @update="updateValue('en', $event)"/></div>
          <div>日文導覽 <SwitchBox :label1="'關閉'" :label2="'開啟'" :defaultValue="ja" @update="updateValue('ja', $event)"/></div>
        </div>
      </div>
      <template  slot="popupL">
        <Dialog :label="'新增類別'" :style="{left: 0}" :title="'upload'" class="upload" v-if="addnew" :show="addnew" @close="addnew=false;category=null;image1=null;image2=null">
          <div class="upload2">
          <div>
            <div>類別名稱</div>
            <Input type="text" v-model="category" :style="{marginTop: '15px', width: '100%', boxSizing: 'border-box', textAlign: 'center'}"/>
          </div>
          <div :style="{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px'}">
            <div>
              <div>標註圖示</div>
              <UploadImage :folder="'map'" @input="image1=$event" :defaultValue="image1" :style="{marginTop: '10px'}"/>
            </div>
            <div>
              <div>點擊圖示</div>
              <UploadImage :folder="'map'" @input="image2=$event" :defaultValue="image2" :style="{marginTop: '10px'}"/>
            </div>
          </div>
          <Btns :style="{display: 'flex'}" @save="save" @cancel="addnew=false;category=null;image1=null;image2=null"/>
          </div>
        </Dialog>
      </template>
    </La>
  </L1>
</template>

<script>
import Input from '../../components/input/normal.vue'
import Btns from '../../components/btn/btns.vue'
import UploadImage from '../../components/input/file2.vue'
import Dialog from '../../components/dialognoPadding2.vue'
import SwitchBox from '../../components/radio/switchboxs1.vue'
import DelBtn from '../../components/btn/del1.vue'
import Table from '../../components/tables/t2.vue'
import AddBtn from '../../components/btn/round.vue'
import L1 from '../../components/layout/L1.vue'
import La from '../../components/layout/La1.vue'
import { postapi, getapi } from '../../store/fetch'
const VUE_APP_MAPLANG = JSON.parse(process.env.VUE_APP_MAPLANG)
export default {
  components: {
    Input,
    Dialog,
    L1,
    La,
    AddBtn,
    Table,
    DelBtn,
    SwitchBox,
    UploadImage,
    Btns
  },
  data () {
    return {
      production: VUE_APP_MAPLANG,
      rows: [],
      defaultcate: {
        category: '(預設)',
        regular: '/point_blue.svg',
        focus: '/point_red.svg',
        removable: false
      },
      addnew: false,
      ja: false,
      tw: false,
      en: false,
      image2: null,
      image1: null,
      category: null
    }
  },
  async mounted () {
    this.ja = await getapi('selections/ja')
    this.tw = await getapi('selections/tw')
    this.en = await getapi('selections/en')
    const r = await getapi('selections/map_category')
    this.rows = [...r.map(e => {
      return {
        ...e, removable: true
      }
    })]
  },
  methods: {
    async remove (index) {
      const rows = JSON.parse(JSON.stringify(this.rows))
      rows.splice(index, 1)
      const ret = await postapi('selections/map_category', { key: 'optionsObj', data: rows })
      this.rows = ret
    },
    async save () {
      const r = await postapi('selections/push/map_category', { category: this.category, regular: this.image1, focus: this.image2 })
      this.rows = [...r.map(e => {
        return {
          ...e, removable: true
        }
      })]
      this.addnew = false
      this.category = null
      this.image1 = null
      this.image2 = null
    },
    async updateValue (lang, value) {
      const ret = await postapi(`selections/${lang}`, { key: 'bool', data: value })
      if (ret) {
        this[lang] = ret
      }
    }
  }

}
</script>

<style lang="scss">
.upload2 {
  .fileInput {
    width: 203px;
    height: 152px;
    label {
      padding: 10px;
      font-size: 16px;
    }
  }

}
.mapsetting {
  .La1_left {
    border-right: 1px solid var(--color-border);
    padding-left: 18px;
  }
}
</style>
<style lang="scss" scoped>
.upload2 {
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.upload {
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 140%;
  text-align: center;
  color: #5E5E5E;
}
.switchs {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 45px;
  margin-top: 10px;
  &>div{
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 24px;
  }
}
.title1 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-inline: 25px 16px;
  height: 76px;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
}
tr {
  border-bottom: 1px solid var(--color-border);
}
td img {
  width: 60px;
  height: 60px;
}
</style>
